import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalBody, ModalFooter } from 'reactstrap';
import { clearModal } from '@shoflo/studio-redux/actions';
import ModalHeader from 'components/Modal/Header';
import { Button } from '@shoflo/polymer';
import { DELETE_RECORDING_MODAL } from '@studio/constants/ModalTypes';
import { deleteRecording } from 'actions/Broadcast';
import {
  StyledModal,
  StyledTitle,
  StyledBody,
  StyledFooter
} from './DeleteRecordingModal.styled';

const title = 'Delete Recording?';
const description = `You won't be able to recover the recording.`;

const DeleteRecordingModal = () => {
  const dispatch = useDispatch();
  const { isModalOpen, recordingId } = useSelector(({ modal }) => ({
    isModalOpen: modal && modal.type === DELETE_RECORDING_MODAL,
    recordingId: modal && modal.initialValue?.recordingId
  }));

  const onModalClose = () => dispatch(clearModal(DELETE_RECORDING_MODAL));

  const footer = (
    <div className="float-end modal-footer">
      <Button
        data-testid="keep-recording-button"
        color="secondary"
        variant="outlined"
        onClick={onModalClose}
      >
        Keep
      </Button>{' '}
      <Button
        data-testid="delete-recording-button"
        color="danger"
        onClick={() => {
          dispatch(deleteRecording(recordingId));
          onModalClose();
        }}
      >
        Delete
      </Button>
    </div>
  );

  if (!isModalOpen) return null;

  return (
    <StyledModal
      isOpen={isModalOpen}
      toggle={onModalClose}
      data-testid="delete-recording-modal"
    >
      <ModalHeader>
        <StyledTitle>{title}</StyledTitle>
      </ModalHeader>
      <ModalBody>
        <StyledBody>{description}</StyledBody>
      </ModalBody>
      <ModalFooter>
        <StyledFooter>{footer}</StyledFooter>
      </ModalFooter>
    </StyledModal>
  );
};

export default DeleteRecordingModal;
